
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Menu, Popover, Transition } from '@headlessui/react'
import {
  AcademicCapIcon,
  BanknotesIcon,
  Bars3Icon,
  BellIcon,
  CheckBadgeIcon,
  ClockIcon,
  ReceiptRefundIcon,
  UsersIcon,
  XMarkIcon,
  DocumentIcon,
  DocumentChartBarIcon,
  PaperClipIcon,
  EllipsisVerticalIcon
} from '@heroicons/react/24/outline'
import { AuthContext } from "../contexts/auth"
import { fetchEmployees, uploadBustePagaMassive } from '../services/api'
import { Link } from "wouter";
import { Disclosure } from '@headlessui/react'
import { PlusIcon, ChevronDownIcon, InformationCircleIcon } from '@heroicons/react/20/solid'
import { DataContext } from '../contexts/data'
import UploadForm from '../components/upload_form'
import {years, months} from '../config'
import Navbar from '../components/navbar'
import CardCaricaBp from '../components/card_carica_bp'
import TourUtente from '../components/tour_utente'
import OpenTour from '../components/tour_utente'
import { menuItems } from '../stores/menuData'
import { useAtom } from 'jotai'
import { currentPageStore } from '../stores/mainStore'
import Root from './root'
import RootEmployee from './root_employee'



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Dashboard() {
  
  const { profile, token, isEmployee } = useContext(AuthContext)

  const [currentPage, setCurrentPage] = useAtom(currentPageStore)

  useEffect(() => {
    setCurrentPage('/')
  }, [])

  if (isEmployee) {
    return (
      <RootEmployee />
    )
  }

  return <Root />
}
